import {Warehouse} from './warehouse';

/**
 * Created by caterina on 04-05-17.
 */
export class Project {
    id: number;
    name: string;
    client: string;
    location: string;
    contact: string;
    phone: string;
    email: string;
    is_finished: boolean;
    code: string;
    warehouse_type: number;
    warehouse: Warehouse;
    parent_inode: number;
    owner: string;

    static copy(project: Project): Project {
        const ret = new Project();
        ret.id = project.id;
        ret.name = project.name;
        ret.client = project.client;
        ret.location = project.location;
        ret.is_finished = project.is_finished;
        ret.code = project.code;
        ret.warehouse = project.warehouse;
        ret.warehouse_type = project.warehouse_type;
        ret.parent_inode = project.parent_inode;
        ret.contact = project.contact;
        ret.phone = project.phone;
        ret.email = project.email;
        ret.owner = project.owner;
        return ret;
    }

    constructor() {
        this.id = undefined;
        this.name = '';
        this.client = '';
        this.location = '';
        this.is_finished = false;
        this.code = '';
        this.warehouse = null;
        this.warehouse_type = null;
        this.parent_inode = null;
        this.contact = '';
        this.phone = '';
        this.email = '';
        this.owner = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/project/project.ts